import { __awaiter, __generator } from "tslib";
import { seasonPreviewMediaConfig, moloStyleShardUrl } from './mediaConfig';
import { SEASON_PREVIEW_LAST_SEASON_KEY } from './constants';
var RETAIL_SEASON_RE = /^[SW]\d{2}$/i;
function fetchJson(url) {
    return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch(url, { credentials: 'omit', cache: 'default' })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error('HTTP ' + response.status + ' for ' + url);
                    }
                    return [2 /*return*/, response.json()];
            }
        });
    });
}
export function fetchCatalog() {
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchJson(seasonPreviewMediaConfig.catalogUrl)];
                case 1:
                    data = (_a.sent());
                    if (!data || !Array.isArray(data.seasons)) {
                        throw new Error('Invalid catalog.json');
                    }
                    return [2 /*return*/, data];
            }
        });
    });
}
function parseUpdatedAt(value) {
    var ts = Date.parse(value);
    return isNaN(ts) ? 0 : ts;
}
function readLastSeasonCode() {
    try {
        var raw = localStorage.getItem(SEASON_PREVIEW_LAST_SEASON_KEY);
        return raw ? String(raw).trim().toUpperCase() : null;
    }
    catch (_a) {
        return null;
    }
}
export function resolveLatestSeasonFromCatalog(catalog) {
    var retail = catalog.seasons.filter(function (entry) { return RETAIL_SEASON_RE.test(String(entry.season || '')); });
    if (!retail.length) {
        throw new Error('No retail seasons in catalog');
    }
    var lastVisited = readLastSeasonCode();
    if (lastVisited) {
        var match = retail.find(function (e) { return String(e.season).toUpperCase() === lastVisited; });
        if (match && match.shard_key) {
            return {
                seasonCode: lastVisited,
                shardUrl: moloStyleShardUrl(match.shard_key),
            };
        }
    }
    var sorted = retail.slice().sort(function (a, b) {
        return parseUpdatedAt(b.updated_at) - parseUpdatedAt(a.updated_at);
    });
    var pick = sorted[0];
    return {
        seasonCode: String(pick.season).toUpperCase(),
        shardUrl: moloStyleShardUrl(pick.shard_key),
    };
}
export function fetchSeasonShardJson(shardUrl) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, fetchJson(shardUrl)];
        });
    });
}
//# sourceMappingURL=catalogApi.js.map